export default "__VITE_ASSET__56LIoaMz__"